import { z } from 'my-zod'
import { subscriptionPlanPriceMetadata } from './subscription-plan-metadata'

export const subscriptionPlanPriceModel = z.object({
  id: z.number(),
  subscriptionPlanId: z.number(),
  isActive: z.boolean(),
  pricePerMonth: z.number(),
  initiationFeePrice: z.number().nullable(),
  subscriptionCreditImpact: z.number(),
  billingIntervalInMonths: z.number(),
  billingProviderPriceId: z.string(),
  billingProviderInitiationFeePriceId: z.string().nullable(),
  metadata: subscriptionPlanPriceMetadata
})

export type subscriptionPlanPriceModel = z.infer<typeof subscriptionPlanPriceModel>
